import {
  InputTextField,
  InputTextFieldProps
} from '@hconnect/uikit/src/lib2/components/inputs/InputTextField/InputTextField'
import currencyFormatter, {Currency} from 'currency-formatter'
import React from 'react'
import NumberFormat from 'react-number-format'

import {countryToCurrencyMap} from '../utils/currency.utils'

type CurrencyInputProps = InputTextFieldProps & {
  countryCode: string
  onChange: (value: string) => void
}

export const CurrencyInput = ({countryCode, onChange, ...otherProps}: CurrencyInputProps) => {
  const currencyInfo = currencyFormatter.findCurrency(
    countryToCurrencyMap[countryCode] || 'USD'
  ) as Currency
  const {symbol, spaceBetweenAmountAndSymbol, decimalSeparator, thousandsSeparator, symbolOnLeft} =
    currencyInfo
  const start = symbolOnLeft
  const adornment = start
    ? `${symbol}${spaceBetweenAmountAndSymbol ? ' ' : ''}`
    : `${spaceBetweenAmountAndSymbol ? ' ' : ''}${symbol}`

  return (
    <NumberFormat
      fixedDecimalScale
      customInput={InputTextField}
      allowEmptyFormatting
      allowLeadingZeros={false}
      allowNegative={false}
      isNumericString={true}
      decimalSeparator={decimalSeparator}
      thousandSeparator={thousandsSeparator}
      allowedDecimalSeparators={['.', ',']}
      {...(start ? {prefix: adornment} : {suffix: adornment})}
      onValueChange={(values) => onChange(values.value)}
      value={otherProps.value as string}
      data-test-id={otherProps['data-test-id']}
      label={otherProps.label}
      wrapperClassName={otherProps.wrapperClassName}
      helperText={otherProps.helperText}
    />
  )
}
